import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { z } from 'zod';
import { cx } from '../lib/cx.js';
import { InlineMarkdown } from '../lib/inline-markdown.js';
import { sanitizeHref } from '../lib/safe-url.js';
import { MarkdownPrimitive } from './markdown.js';
export const CALLOUT_VARIANTS = ['info', 'warn', 'success', 'danger'];
export const CalloutPropsSchema = z
    .object({
    variant: z.enum(CALLOUT_VARIANTS).default('info'),
    title: z.string().optional(),
    body: z.string(),
    // Not part of the M1 `callout` block contract (@almanac/contracts digest.ts
    // has no link field), but M2 generative specs may want an actionable
    // callout link. Agent-supplied — scheme-validated at render time.
    href: z.string().optional(),
    linkLabel: z.string().optional(),
})
    .strict();
// Full literal class strings per variant (no interpolation) so Tailwind can
// statically see every utility. Each maps onto a semantic token so both
// schemes are covered without `dark:` variants.
const VARIANT_CONTAINER_CLASS = {
    info: 'border-info/25 bg-info/8',
    warn: 'border-warning/25 bg-warning/8',
    success: 'border-success/25 bg-success/8',
    danger: 'border-danger/25 bg-danger/8',
};
const VARIANT_TITLE_CLASS = {
    info: 'text-info',
    warn: 'text-warning',
    success: 'text-success',
    danger: 'text-danger',
};
/** Renders a `callout` block. */
export function CalloutPrimitive({ variant = 'info', title, body, href, linkLabel }) {
    const safeHref = sanitizeHref(href);
    return (_jsxs("div", { className: cx('rounded-lg border p-4', VARIANT_CONTAINER_CLASS[variant]), children: [title ? (_jsx("p", { className: cx('mb-1 text-sm font-semibold', VARIANT_TITLE_CLASS[variant]), children: _jsx(InlineMarkdown, { children: title }) })) : null, _jsx("div", { className: "[&>div>:last-child]:mb-0", children: _jsx(MarkdownPrimitive, { body: body }) }), safeHref ? (_jsx("a", { href: safeHref, target: "_blank", rel: "noopener noreferrer nofollow", className: cx('mt-2 inline-block text-sm font-medium underline underline-offset-4', VARIANT_TITLE_CLASS[variant]), children: linkLabel ?? safeHref })) : null] }));
}
